module.exports = __webpack_public_path__ + "img/99.2.4c3d0cac.png";